import React, { useState, useEffect, useContext } from "react";

import AdvancedSearchContext from "context/AdvancedSearchContext";
import Meters from "./Generic/Meters/Meters";
import Reference from "./Generic/Reference/Reference";

import NavPills from "components/NavPills/NavPills.js";

import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import { makeStyles, withStyles } from "@mui/styles";
import Divider from "@mui/material/Divider";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import NatureIcon from "@mui/icons-material/Nature";
import OpacityIcon from "@mui/icons-material/Opacity";
import FireplaceIcon from "@mui/icons-material/Fireplace";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WhatshotIcon from '@mui/icons-material/Whatshot';

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginLeft: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function Energy() {
  const appContext = useContext(AdvancedSearchContext);

  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [counter, setCounter] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <NavPills
        color="customGreen"
        horizontal={{
          tabsGrid: { xs: 12, sm: 12, md: 2, lg : 1},
          contentGrid: { xs: 12, sm: 12, md: 10, lg : 11 },
        }}
        tabs={[
          {
            tabButton: "Electricité",
            tabIcon: FlashOnIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                    {<Meters energy={"electricity"} parameters={"meters"}/>}
                  </TabPanel>
                  <TabPanel value={1} index={1}>
                  {<Reference energy={"electricity"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Gaz",
            tabIcon: FireplaceIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                  {<Meters energy={"gas"} parameters={"meters"}/>}
                  </TabPanel>

                  <TabPanel value={1} index={1}>
                  {<Reference energy={"gas"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Eau",
            tabIcon: OpacityIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                  {<Meters energy={"water"} parameters={"meters"}/>}
                  </TabPanel>
                  <TabPanel value={1} index={1}>
                  {<Reference energy={"water"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Réseau de chaleur",
            tabIcon: WhatshotIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                  {<Meters energy={"heat"} parameters={"meters"}/>}
                  </TabPanel>

                  <TabPanel value={1} index={1}>
                  {<Reference energy={"heat"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Réseau frigorifique",
            tabIcon: AcUnitIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                  {<Meters energy={"cold"} parameters={"meters"}/>}
                  </TabPanel>

                  <TabPanel value={1} index={1}>
                  {<Reference energy={"cold"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Fioul",
            tabIcon: LocalGasStationIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                  {<Meters energy={"fuel"} parameters={"meters"}/>}
                  </TabPanel>

                  <TabPanel value={1} index={1}>
                  {<Reference energy={"fuel"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Bois",
            tabIcon: NatureIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                  {<Meters energy={"wood"} parameters={"meters"}/>}
                  </TabPanel>

                  <TabPanel value={1} index={1}>
                  {<Reference energy={"wood"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Gaz propane",
            tabIcon: FireplaceIcon,
            tabContent: (
              <TabContext value={value}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={value}
                      onChange={handleTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Liste des compteurs attribués"
                        value={0}
                      />
                      <StyledTab label="Références Analyse" value={1} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={0} index={0}>
                  {<Meters energy={"propane"} parameters={"meters"}/>}
                  </TabPanel>

                  <TabPanel value={1} index={1}>
                  {<Reference energy={"propane"} parameters={"reference"}/>}
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
        ]}
      />
    </div>
  );
}
